module.exports = __webpack_public_path__ + "static/img/classoverlogo1.9fd444f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/classoverlogo1.svg
// module id = 4A0c
// module chunks = 1